import React, { useCallback, useMemo, useState } from 'react';

import Form from '@rjsf/mui';
import validator from '@rjsf/validator-ajv8';
import { useHistory } from 'react-router-dom';

import { Button } from '@mui/material';

import ReservationService from '../../../services/ReservationService';
import { reportError } from '../../../utils/reportError';
import ErrorListDisplay from '../ErrorListDisplay';

import { buttonMessages, buttonStates } from './states/submitButton';

const uiSchema = {
  rate_plans_groups: {
    'ui:options': { orderable: false },
    items: {
      id: { 'ui:widget': 'hidden' },
      rate_plans: { 'ui:options': { orderable: false } },
    },
  },
};

function RatePlansGroupsForm({ vendorId, schema: baseSchema, ratePlansGroups }) {
  const history = useHistory();

  /** ---------- Build schema only once ---------- */
  const schema = useMemo(() => {
    return {
      ...baseSchema,
      properties: {
        ...baseSchema.properties,
        rate_plans_groups: {
          ...baseSchema.properties.rate_plans_groups,
          items: {
            ...baseSchema.properties.rate_plans_groups.items,
            title: 'Rate plan group',
          },
        },
      },
    };
  }, [baseSchema]);

  /** ---------- Component state ---------- */
  const [formData, setFormData] = useState({
    rate_plans_groups: ratePlansGroups,
  });
  const [saveState, setSaveState] = useState(buttonStates.default);
  const [errors, setErrors] = useState([]);

  /** ---------- Handlers ---------- */
  const handleSubmit = useCallback(
    ({ formData }) => {
      setSaveState(buttonStates.saving);
      setFormData(formData);

      ReservationService.updateRatePlansGroups(vendorId, formData)
        .then(() => {
          setSaveState(buttonStates.saved);
          setErrors([]);
          history.push(`/vendors/${vendorId}/rate-plans-groups`);
        })
        .catch((e) => {
          const apiErrors = [];
          if (e.name === 'ValidationError') {
            e.errors.filter((x) => x.path !== 'id_salesforce_external').forEach((err) => apiErrors.push(err.message));
          }
          setSaveState(buttonStates.failed);
          setErrors(apiErrors);
          reportError(e);
        });
    },
    [history, vendorId],
  );

  return (
    <Form schema={schema} uiSchema={uiSchema} formData={formData} validator={validator} onSubmit={handleSubmit}>
      <div className="button-container">
        <Button type="submit" variant="contained" className={saveState}>
          {buttonMessages[saveState]}
        </Button>
      </div>

      {errors.length > 0 && <ErrorListDisplay messages={errors} />}
    </Form>
  );
}

export default RatePlansGroupsForm;
